<script lang="ts">
  import Sidebar from '$lib/sidebar/Sidebar.svelte';
  import Footer from '$lib/footer/Footer.svelte';
  import { demoToc } from '$lib/sidebar/SidebarContent.js';
  import AppBar from '$lib/appbar/AppBar.svelte';
  import type { CategoryProps } from '$lib/metadataTypes/MetaTypes';

	let { children,  data }: CategoryProps = $props();
	
	// --- Derived title (recomputes when `data` changes)
	const fullTitle: string = $derived(
		`${data.category.title} – ${data.site.title}`
	);
</script>

<svelte:head>
  <title>{fullTitle}</title>

  <!-- Section-level defaults (safe fallbacks pages can override) -->
  <meta name="description" content={data.category.description} />
  <meta property="og:site_name" content={data.site.title} />
  <meta property="og:type" content="website" />
  {#if data.site.image}
    <meta property="og:image" content={data.site.image} />
  {/if}
  <meta name="twitter:card" content="summary_large_image" />
</svelte:head>


<main class="main-window">
  <AppBar />
  <div class="content-box">
    <div class="page-container">
      <section class="page-side-nav">
        <Sidebar tocContent={demoToc} />
      </section>

      <section class="page-content-container">
        {@render children()}
      </section>
    </div>
  </div>
  <Footer />
</main>